import { CheckCircle } from "@mui/icons-material";
import axios from "axios";
import React, { useState } from "react";
import Logo from "../assets/logo.png";
import PhoneInput from "react-phone-input-2";
const SMSPage = ({ qrData }) => {
  const [notification, setNotification] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [data, setData] = useState({
    phone_number: "",
  });
  const submitForm = async (e) => {
    e.preventDefault();
    if (!data.phone_number) {
      return setError("Phone number is required");
    }
    setLoading(true);
    const response = await axios({
      method: "post",
      url: "/chats/sendSMSByPhoneNumber",
      data: {
        to: data.phone_number,
        message: qrData.sms,
        user_uuid: qrData.user_uuid,
      },
    });
    if (response.data.success) {
      setNotification("Message sent successfully");
      setTimeout(() => {
        setNotification("");
      }, 3000);
      window.location.href = `/success/Messages sent successfully`;
    }
    setLoading(false);
  };
  return (
    <div className="sign_up_page">
      <div className="three-corner-curve"></div>
      {notification ? (
        <div className="success_dialogue">
          <div className="success_dialogue_icon">
            <CheckCircle />
          </div>
          <div className="success_dialogue_heading">{notification}</div>
        </div>
      ) : (
        ""
      )}
      <div className="sign_up_logo">
        <img src={Logo} alt="logo" />
      </div>
      <div className="sign_up_form_body">
        <div className="sign_up_form_heading">
          You are about to receive message from
        </div>
        <div className="sign_up_form_sub_heading">
          {qrData?.first_name || ""} {qrData?.last_name || ""}
        </div>
        {/* <div className="sign_up_form_sub_heading">{qrData?.company || ""}</div> */}
        {/* make form for data  */}
        <div className="sign_up_form">
          <div className="input-wrapper">
            <PhoneInput
              country={"us"} // Default country code
              value={data.phone_number}
              onChange={(phone, country) =>
                setData((prev) => ({
                  ...prev,
                  phone_number: phone,
                  country_code: country.dialCode,
                }))
              }
              inputStyle={{
                width: "250px",

                marginBottom: "1rem",
                border: "none",
                borderRadius: "5px",
                boxShadow: "none",
                height: "30px",
                fontSize: "1rem",
              }}
            />
            {data.phone_number && (
              <span
                className="clear-icon"
                onClick={() =>
                  setData((prev) => ({ ...prev, phone_number: "" }))
                }
              >
                &times;
              </span>
            )}
          </div>

          {loading ? (
            <button id="loading-screen">
              <svg viewBox="0 0 100 100">
                <path
                  d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                  fill="#ffffff"
                  stroke="none"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    dur="1s"
                    repeatCount="indefinite"
                    keyTimes="0;1"
                    values="0 50 51;360 50 51"
                  ></animateTransform>
                </path>
              </svg>
            </button>
          ) : (
            <button onClick={submitForm}>Save</button>
          )}
          {error ? <p style={{ color: "red" }}>{error}</p> : ""}
        </div>
      </div>
    </div>
  );
};

export default SMSPage;
